// extracted by mini-css-extract-plugin
export default {"wrapper":"Home_wrapper__kLS7V","header":"Home_header__0VSLp","left":"Home_left__JGUbh","right":"Home_right__Vl6+m"};